var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    transform: "translate(-1862.813 -1863.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_36",
    "data-name": "Mask Group 36",
    transform: "translate(25798.813 14322.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(-23958 -12883.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "summarize_FILL0_wght400_GRAD0_opsz48",
    d: "M137.682,236.182A1.724,1.724,0,0,1,136,234.5V217.682A1.724,1.724,0,0,1,137.682,216h8.855l5.55,5.55V234.5a1.724,1.724,0,0,1-1.682,1.682Zm0-1.682H150.4V222.487h-4.793v-4.805h-7.93Zm0-16.819v0Z",
    transform: "translate(-110 210.068)",
    fill: "#918f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M-807-2925.224l1.166-1.167,2.546,2.545,5.026-5.025,1.191,1.165-6.217,6.216Z",
    transform: "translate(836.08 3363)",
    fill: "#918f90"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudits);
export default __webpack_public_path__ + "static/media/audits.740cabd0cc6335bc15a7a43613850d41.svg";
export { ForwardRef as ReactComponent };